<template>
    <el-container>
        <el-main>
            <div>

            <el-dialog title="权限管理" :close-on-click-modal=false  :visible.sync="addPermission" width="35%" >
                <div class="el-dialog-div">
                    <el-tree
                            :data="roleSystemData"
                            show-checkbox
                            ref="dataTree"
                            :default-expand-all="expandAll"
                            :default-checked-keys="checkedKeys"
                            :check-strictly="true"
                            node-key="permissionId"
                            :props="defaultProps"
                    >
                    </el-tree>
                </div>
                <span slot="footer" class="dialog-footer">
                        <el-button @click="addPermission = false">取 消</el-button>
                        <el-button type="primary" @click="savePermission">确 定</el-button>
                    </span>
            </el-dialog>
            <el-dialog :title="roleTitle" :close-on-click-modal=false :visible.sync="addRole" :before-close="handleDialogClose">
                <el-form ref="roleForm"  :model="formData" :rules="rules" label-width="100px"  class="demo-ruleForm">
                    <el-form-item label="角色名称" prop="roleName">
                        <el-input v-model="formData.roleName"  placeholder="角色名称" :disabled="isUpdate"></el-input>
                    </el-form-item>
                    <el-form-item label="机构" prop="orgCode" v-if="orgType == 1">
                        <el-select size="small" placeholder="组织机构" v-model="formData.orgCode"  style="margin-right: 10px;">
                            <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="角色类型" prop="status">
                        <el-radio v-model="formData.roleType" :label= "0" >其他</el-radio>
                        <el-radio v-model="formData.roleType" :label= "1" >机构管理员</el-radio>
                        <el-radio v-model="formData.roleType" :label= "2" >助教</el-radio>
                        <el-radio v-model="formData.roleType" :label= "3" >远汉运营</el-radio>
                        <el-radio v-model="formData.roleType" :label= "4" >代理</el-radio>
                    </el-form-item>
                    <el-form-item  label="是否启用" prop="status">
                        <el-radio v-model="formData.status" :label= "1" >启用</el-radio>
                        <el-radio v-model="formData.status" :label= "2" >禁用</el-radio>
                    </el-form-item>
                    <el-form-item  label="角色描述" prop="description">
                        <el-input type="textarea" :rows="3"  placeholder="请输入内容" v-model="formData.description" ></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="handleDialogClose">取 消</el-button>
                    <el-button type="primary" @click="saveRole('roleForm')">确 定</el-button>
                </div>
            </el-dialog>
            </div>

            <el-form :model="searchData" ref="searchDate"  label-position="top" label-width="80px">
                <el-row>
                    <el-col :span="5">
                        <el-form-item label="角色名称" prop="roleName" class="cls-col" style="width: 70%">
                            <el-input v-model="searchData.roleName" placeholder="角色名称" size="small" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" v-if="orgType == 1">
                        <el-form-item label="机构" prop="orgCode" >
                            <el-select size="small" clearable placeholder="组织机构" v-model="searchData.orgCode" style="margin-right: 10px;">
                                <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="角色类型" prop="status">
                            <el-select v-model="searchData.roleType" clearable  placeholder="角色类型" size="small" style="width: 70%">
                                <el-option label="机构管理员" :value="1"></el-option>
                                <el-option label="助教" :value="2"></el-option>
                                <el-option label="远汉运营" :value="3"></el-option>
                                <el-option label="其他" :value="0"></el-option>
                                <el-option label="代理" :value="4"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="角色状态" prop="status">
                            <el-select v-model="searchData.status" clearable  placeholder="角色状态" size="small" style="width: 70%">
                                <el-option label="启用" :value="1"></el-option>
                                <el-option label="禁用" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item>
                    <el-button type="primary" size="small" plain @click="search()">查询</el-button>
                </el-form-item>
            </el-form>
            <el-button type="success" icon="el-icon-circle-plus-outline" size="small" round @click="addRole = true, roleTitle='添加角色', isUpdate = false" class="but-cls">添加</el-button>
            <el-button type="danger" icon="el-icon-delete" size="small" round @click="deleteMore" class="but-cls">删除</el-button>

            <el-table
                    :data="roleData"
                    border
                    highlight-current-row
                    v-loading="loading"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
            >
                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column
                        type="index"
                        label="序号"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="roleName"
                        label="角色名称"
                        align="center"
                        width="200"
                >
                </el-table-column>
                <el-table-column
                    prop="orgName"
                    label="所属机构"
                >
                </el-table-column>
                <el-table-column
                    prop="roleType"
                    label="角色类型"
                    width="200"
                    :formatter="f_roleType"
                >
                </el-table-column>
                <el-table-column
                        prop="status"
                        label="状态"
                        width="100"
                        :formatter="roleStatus"
                >
                </el-table-column>
                <el-table-column
                        prop="modifyTime"
                        label="最后修改时间"
                        width="200"
                        :formatter="dateFormat"
                >
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="200"
                >
                    <template slot-scope="scope">
                        <el-button @click="addPermissionData(scope.$index, scope.row)"  size="small" type="text">增加权限</el-button>
                        <el-button @click="updateRole(scope.$index, scope.row)" type="text"  size="small">修改</el-button>
                        <el-button @click="deleteRole(scope.$index, scope.row)" type="text"  size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="pageSize"
                    :current-page.sync="currentPage"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    style="margin-top: 10px; float: right; margin-right: 10px">
            </el-pagination>
        </el-main>
    </el-container>
</template>

<script>
    import https from '@/https.js';
    import {dateFormat} from '@/api/utils.js';
    import { Buried } from '@/api/decorators';
    
    const formData = {
        roleId: '',
        orgCode: '',
        roleName: '',
        status: 1,
        isDeleted: 1,
        permissionId: '',
        roleType: 0,
        isSystem: 0
    };
    export default {
        name: 'roleManager',
        components: {
        },

        data() {
            const generateData2 = _ => {
                const data = [{
                    label:'上海',
                    key: 1,
                    children: [{
                        label:'北京',
                        key: 2
                    },{
                        label:'北京',
                        key: 3
                    }]
                    }
                ];
                return data;
            };
            return {
              orgType: '',
              org: [],
                rules: {
                  
                    roleName: [
                        { required: true, message: '请输入角色名', trigger: 'blur' },
                        {  max: 50, message: '长度不得超过 50 个字符', trigger: 'blur' }
                    ],
                  orgCode: [
                        { required: true, message: '请选择机构', trigger: 'blur' }
                    ],
                    description: [
                        {  max: 500, message: '长度不得超过 500 个字符', trigger: 'blur' }
                    ]
                },
                defaultProps: {children: 'children', label: 'menuName'},
                expandAll: true,
                roleData: [],
                searchData: {
                    isSystem: '',
                    roleType: '',
                    orgCode: '',
                    roleId: '',
                    roleName: '',
                    status: '',
                    system: true,
                    page: 0,
                    size: 10
                },
                formData: JSON.parse(JSON.stringify(formData)),
                pageSize:10,
                loading: false,
                total: 0,
                addPermission: false,
                addRole: false,
                roleSystemData: [],
                multipleSelection : [],
                _roleId: '',
                checkedKeys: [],
                roleTitle: '',
                currentPage: 1,
                isUpdate: false
            };
        },
        methods: {
            handleDialogClose() {
                let that = this;
                that.addRole = false;
                that.isUpdate = false;
                that.formData = JSON.parse(JSON.stringify(formData));
                this.$nextTick(function() {
                  that.$refs.roleForm.clearValidate();
                });
            },
            handleSelectionChange(val) {
                this.multipleSelection = [];
                for(let index in val) {
                    this.multipleSelection[index] =  val[index].roleId;
                }
            },
            deleteMore() {
                let roleLength = this.multipleSelection.length;
                this.$confirm('此操作将删除'+roleLength+'条角色信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(()=>{
                    let params =  {
                      roleIdList: this.multipleSelection
                    };
                    https.fetchPost('/managerRole/deleteByRoleIdList',params , 'json').then((data) => {
                        let code = data.data.code;
                        let msg = data.data.msg;
                        if(code == '200') {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.search();
                        } else {
                            this.$message({
                                type: 'info',
                                message: '删除失败:'+msg
                            });
                        }
                    }).catch(err=>{
                        this.$message.error('网络错误');
                        }
                    );
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleSizeChange() {

            },
            handleCurrentChange(val) {
                this.search(val);
            },

            roleStatus(row, column, cellValue, index) {
                if(cellValue == 1) {
                    return '启用';
                }else if(cellValue == 2) {
                    return '禁用';
                } else {
                    return '其他';
                }
            },
            saveRole(formName) {
                this.$refs[formName].validate((valid) => {
                    if (!valid) {
                        this.$message.error('请正确填写信息！');
                        return false;
                    }else {
                        let params = this.formData;
                        let url = '/managerRole/addRole';
                        if(this.formData.roleId != '') {
                            url = '/managerRole/updateRole';
                        }
                        https.fetchPost(url,params ,'json').then((data) => {
                            let code = data.data.code;
                            let msg = data.data.msg;
                            if(code == '200') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.addRole = false;
                                this.formData = JSON.parse(JSON.stringify(formData));
                                this.search();
                            } else {
                                this.$message.error('操作失败:'+msg);
                            }

                        }).catch(err=>{
                            console.log(err);
                                this.$message.error('网络错误');
                            }
                        );
                    }
                });
            },
            deleteRole (index, row) {
                this.$confirm('此操作将删除该角色信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(()=>{
                    let params = {
                      roleIdList: row.roleId
                    };
                    https.fetchPost('/managerRole/deleteByRoleIdList',params , 'json').then((data) => {
                        let code = data.data.code;
                        let msg = data.data.msg;
                        if(code == '200') {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.search();
                        } else {
                            this.$message({
                                type: 'info',
                                message: '删除失败:'+msg
                            });
                        }
                    }).catch(err=>{
                        this.$message.error('网络错误');
                        }
                    );
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            updateRole(index, row) {
                this.formData = JSON.parse(JSON.stringify(row));
                this.addRole = true;
                this.isUpdate = true;
                this.roleTitle = '修改角色';
            },
            //添加权限
            addPermissionData(index, row) {
                this.addPermission = true;
                if(this.$refs.dataTree) {
                    this.$refs.dataTree.setCheckedKeys([]);
                }
                this._roleId = row.roleId;
                let params = {
                    roleId: row.roleId
                };
                
                //获取角色的最大权限
                this.getAccountPermission(row.roleId);
                // 角色已有权限
                https.fetchPost('/managerRole/getRolePermission',JSON.parse(JSON.stringify(params)),'json' ).then((data) => {
                    let code = data.data.code;
                    if(code == '200') {
                        let permissions = data.data.data;
                        let keys = [];
                        for(let index in permissions) {
                            keys.push(permissions[index].permissionId);
                        }
                        this.checkedKeys = keys;
                    }
                }).catch(err=>{
                        this.$message.error('网络错误');
                    }
                );
            },
            savePermission() {
                let params = {
                    orgCode: '',
                    permissionIdList: this.$refs.dataTree.getCheckedKeys(),
                    roleId: this._roleId
                };
                https.fetchPost('/managerRole/updateRolePermission',params,'json' ).then((data) => {
                    let code = data.data.code;

                    if(code == '200') {
                        this.addPermission = false;
                        this.$message({
                            type: 'success',
                            message: '添加成功!'
                        });
                    } else {
                        this.$message({
                            message: '添加失败:'+data.data.msg,
                            info: 'success'
                        });
                    }
                }).catch(err=>{
                    this.$message.error('网络错误');
                    }
                );
            },
            
            getOrgPermission() {
              let permissionParams = {
                orgCode: '1234',
                status: 1
              };
              https.fetchGet('/managerPermission/selectPermission',permissionParams,'form' ).then((data) => {
                let code = data.data.code;
                if(code == '200') {
                  this.roleSystemData = data.data.data;
                }
              }).catch(err=>{
                    console.log(err);
                  }
              );
            },
          
              getAccountPermission(roleId) {
                let permissionParams = {
                  roleId: roleId
                };
                https.fetchPost('/managerPermission/selectAccountPermissionTree',permissionParams,'json' ).then((data) => {
                  let code = data.data.code;
                  if(code == '200') {
                    this.roleSystemData = data.data.data;
                  }
                }).catch(err=>{
                      console.log(err);
                    }
                );
              },
          
            search(val) {
                this.searchData.size = this.pageSize;
                if(val) {
                    this.searchData.page = val;
                } else {
                    this.searchData.page = 1;
                    this.currentPage = 1;
                }
                let params = this.searchData;
                https.fetchPost('/managerRole/searchRole',JSON.parse(JSON.stringify(params)),'json' ).then((data) => {
                    let code = data.data.code;
                    if(code == '200') {
                        this.roleData = data.data.data.list;
                        this.total = data.data.data.total;
                        this.loading = false;
                    }
                }).catch(err=>{
                        console.log(err);
                    }
                );
            },
            dateFormat(row, column, cellValue, index) {
                if(cellValue != null) {
                    return dateFormat(cellValue);
                } else {
                    return cellValue;
                }
            },
            f_roleType(row) {
              if(row.roleType == 0) {
                return '其他';
              }
              if (row.roleType == 1) {
                return '机构管理员';
              }
              if (row.roleType == 3) {
              return '远汉运营';
              }
              if(row.roleType == 2) {
                return '助教';
              }
              if(row.roleType == 4) {
                return '代理';
              }
          },
          selectOrg() {
            https.fetchGet('/managerOrganization/getOrganizationList', '', 'from').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                this.org = data.data.data;
              } else {
                this.$message({
                  type: 'info',
                  message: msg
                });
              }

            }).catch(err => {
                  this.$message.error('网络错误');
                }
            );
          },
        },
        created: function () {
            this.orgType = this.$store.state.orgType;
            this.search();
            this.selectOrg();
        }


    };
</script>

<style scoped>
.add-button {
    margin-bottom: 5px;
}
.but-cls {
    margin-bottom: 10px;
}
.cls-col {
    margin-right: 20px;
}
.el-dialog-div{
    height: 60vh;
    overflow: auto;
}

</style>
